import {BaseStyle} from "../base-style";

export class BaseProps {
  children: Object;
  style: BaseStyle = {};
  className: String;
}
